import { Injectable, inject } from '@angular/core';
import { ForgotPasswordPayload, LoginPayload, OtpResendPayload, OtpVerifyPayload, RegistrationPayload, ResetPasswordPayload, SsoExchangePayload } from './auth.models';
import { HttpService } from '../../core/services/http.service';

@Injectable({ providedIn: 'root' })
export class AuthApi {
  private readonly httpService = inject(HttpService);

  register(payload: RegistrationPayload){
    return this.httpService.post('auth/register', payload);
  }

  login(payload: LoginPayload){
    return this.httpService.post('auth/login', payload, false, true);
  }

  refreshToken(){
    return this.httpService.get('auth/refresh-token', false, true);
  }

  verifyOtp(payload: OtpVerifyPayload){
    return this.httpService.post('auth/otp/verify', payload);
  }

  resendOtp(payload: OtpResendPayload){
    return this.httpService.post('auth/otp/resend', payload);
  }

  forgotPassword(payload: ForgotPasswordPayload){
    return this.httpService.post('auth/password-reset', payload);
  }

  forgotPasswordReset(payload: ResetPasswordPayload){
    return this.httpService.post('auth/password-reset/confirm', payload);
  }

  logout(){
    return this.httpService.get('auth/logout', false, true);
  }

  changePassword(payload: { old_password: string; new_password: string }){
    return this.httpService.post('auth/change-password', payload);
  }

  setPassword(payload: { token: string; password: string }){
    return this.httpService.post('auth/set-password', payload);
  }

  orgExchange(payload: SsoExchangePayload){
    return this.httpService.post('auth/org-exchange', payload, true, true);
  }
}
